<template>
  <div>
    <a-layout id="components-layout-demo-custom-trigger">
      <a-layout-sider v-model="collapsed" :trigger="null" collapsible width="256" class="custom-sider">
        <div class="logo" @click="$router.push('/')" style="cursor: pointer;">
          <span class="logo-icon">X</span>
          <span class="logo-text" v-if="!collapsed">xxxxproxy</span>
        </div>
        <a-menu 
          theme="light" 
          mode="inline" 
          :selected-keys="selectedKeys" 
          :open-keys="openKeys" 
          @openChange="onOpenChange" 
          @click="handleMenuClick"
          class="custom-menu"
        >
          <a-sub-menu key="sub1">
            <span slot="title"><a-icon type="safety-certificate" /><span>{{ $t('menu.auth') }}</span></span>
            <a-menu-item key="2">
              {{ $t('menu.auth') }}
            </a-menu-item>
            <!-- <a-menu-item key="3">
              {{ $t('menu.subaccount') }}
            </a-menu-item> -->
            <a-menu-item key="4">
              {{ $t('menu.trafficRecord') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub3">
            <span slot="title"><a-icon type="file-text" /><span>{{ $t('menu.recordQuery') }}</span></span>
            <a-menu-item key="6">
              {{ $t('menu.flowChangeRecord') }}
            </a-menu-item>
            <a-menu-item key="7">
              {{ $t('menu.loginRecord') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub4">
            <span slot="title"><a-icon type="tool" /><span>{{ $t('menu.proxyCheck') }}</span></span>
            <a-menu-item key="8">
              {{ $t('menu.proxyCheck') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub5">
            <span slot="title"><a-icon type="cloud-server" /><span>{{ $t('menu.staticProxy') }}</span></span>
            <a-menu-item key="9">
              {{ $t('menu.staticList') }}
            </a-menu-item>
            <a-menu-item key="10">
              {{ $t('menu.staticPurchase') }}
            </a-menu-item>
            <a-menu-item key="11">
              {{ $t('menu.broadcastPurchase') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2">
            <span slot="title"><a-icon type="user" /><span>{{ $t('menu.personalCenter') }}</span></span>
            <a-menu-item key="5">
              {{ $t('menu.personalSettings') }}
            </a-menu-item>
            <a-menu-item key="logout">
              {{ $t('menu.logout') }}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header style="background: #fff; padding: 0">
          <div class="header-content">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
            <div class="header-right">
              <a-dropdown :trigger="['hover']" placement="bottomCenter">
                <a-button type="link" class="lang-btn" style="margin-right: 20px;">
                  <a-icon type="global" /> {{ $i18n.locale === 'zh-CN' ? '中文' : 'EN' }} <a-icon type="down" style="font-size: 10px; margin-left: 2px;" />
                </a-button>
                <a-menu slot="overlay" @click="handleLangClick">
                  <a-menu-item key="zh-CN">🇨🇳 中文</a-menu-item>
                  <a-menu-item key="en-US">🇺🇸 English</a-menu-item>
                </a-menu>
              </a-dropdown>
              <a-dropdown>
                <span class="user-dropdown-link">
                  <a-avatar size="small" icon="user" class="avatar" />
                  <span class="username">{{ username }}</span>
                  <a-icon type="down" />
                </span>
                <a-menu slot="overlay">
                  <a-menu-item key="profile" @click="handleProfileClick">
                    <a-icon type="user" />{{ $t('menu.personalCenter') }}
                  </a-menu-item>
                  <!-- <a-menu-item key="settings">
                    <a-icon type="setting" />账户设置
                  </a-menu-item> -->
                  <a-menu-divider />
                  <a-menu-item key="logout" @click="handleLogout">
                    <a-icon type="logout" />{{ $t('menu.logout') }}
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </a-layout-header>
        <a-layout-content
          :style="{ margin: '0', padding: '0', background: '#f3f4f6', minHeight: '280px' }"
        >
          <transition name="fade-transform" mode="out-in">
            <router-view />
          </transition>
        </a-layout-content>
      </a-layout>
    </a-layout>

    <!-- 悬浮客服按钮 -->
    <div id="kefu" style="position: fixed; bottom: 40px; right: 40px; z-index: 999;">
      <label slot="reference" class="topBtn" @click="Kefu()" :title="$t('menu.customerService')" style="cursor: pointer; display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; border-radius: 50%; background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); color: white; font-size: 24px; box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4); transition: all 0.3s ease;">
        <a-icon type="customer-service" />
      </label>
    </div>
    
    <!-- 客服弹窗 -->
    <a-modal
        v-model="visible"
        :title="$t('menu.customerService')"
        :footer="null"
        width="600px"
        :maskClosable="true"
      >
      <div style="display: flex;flex-direction: column;padding: 20px 0" v-for="item in FormatList" :key="item.id">
        <div style="display: flex;align-items: center;margin-bottom: 10px;">
          <span>{{ item.contacttype }} :</span> <a :href='item.link'> {{ item.contact }}</a>
        </div>
        <div class="QrcodeWrap" v-if="item.contacttype == 'wechat' || item.contacttype == 'qq'">
          <qrcode-vue :value="item.contact"  :size="size" level="L" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode-vue';

export default {
  name: 'BasicLayout',
  components: {
    QrcodeVue
  },
  data() {
    return {
      collapsed: false,
      username: localStorage.getItem('userName') || 'User',
      openKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5'],
      rootSubmenuKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5'],
      selectedKeys: ['2'],
      // 客服相关
      visible: false,
      FormatList: [],
    };
  },
  watch: {
    $route: {
      handler: function() {
        this.updateMenu();
      },
      immediate: true
    }
  },
  created() {
    this.updateMenu();
  },
  methods: {
    updateMenu() {
      const path = this.$route.path;
      if (path === '/dashboard/auth') {
        this.selectedKeys = ['2'];
      } 
      // else if (path === '/dashboard/subaccount') {
      //   this.selectedKeys = ['3'];
      // } 
      else if (path === '/dashboard/traffic') {
        this.selectedKeys = ['4'];
      } else if (path === '/record/flow-change') {
        this.selectedKeys = ['6'];
      } else if (path === '/record/login') {
        this.selectedKeys = ['7'];
      } else if (path === '/check/proxy') {
        this.selectedKeys = ['8'];
      } else if (path === '/static/list') {
        this.selectedKeys = ['9'];
      } else if (path === '/static/purchase') {
        this.selectedKeys = ['10'];
      } else if (path === '/static/broadcast-purchase') {
        this.selectedKeys = ['11'];
      } else if (path === '/user/profile') {
        this.selectedKeys = ['5'];
      }
    },
    onOpenChange(openKeys) {
      // 允许所有菜单同时展开
      this.openKeys = openKeys;
    },
    handleProfileClick() {
      if (this.$route.path !== '/user/profile') {
        this.$router.push('/user/profile');
      }
    },
    handleMenuClick({ key }) {
      if (key === '2') {
        if (this.$route.path !== '/dashboard/auth') {
          this.$router.push('/dashboard/auth');
        }
      } 
      // else if (key === '3') {
      //   if (this.$route.path !== '/dashboard/subaccount') {
      //     this.$router.push('/dashboard/subaccount');
      //   }
      // } 
      else if (key === '4') {
        if (this.$route.path !== '/dashboard/traffic') {
          this.$router.push('/dashboard/traffic');
        }
      } else if (key === '6') {
        if (this.$route.path !== '/record/flow-change') {
          this.$router.push('/record/flow-change');
        }
      } else if (key === '7') {
        if (this.$route.path !== '/record/login') {
          this.$router.push('/record/login');
        }
      } else if (key === '8') {
        if (this.$route.path !== '/check/proxy') {
          this.$router.push('/check/proxy');
        }
      } else if (key === '9') {
        if (this.$route.path !== '/static/list') {
          this.$router.push('/static/list');
        }
      } else if (key === '10') {
        if (this.$route.path !== '/static/purchase') {
          this.$router.push('/static/purchase');
        }
      } else if (key === '11') {
        if (this.$route.path !== '/static/broadcast-purchase') {
          this.$router.push('/static/broadcast-purchase');
        }
      } else if (key === '5') {
        if (this.$route.path !== '/user/profile') {
          this.$router.push('/user/profile');
        }
      } else if (key === 'logout') {
        this.handleLogout();
      }
    },
    handleLangClick({ key }) {
      this.$i18n.locale = key;
      localStorage.setItem('language', key);
    },
    handleLogout() {
      localStorage.clear();
      this.$message.success(this.$t('header.logoutSuccess'));
      this.$router.push('/login');
    },
    // 获取客服联系方式
    getCommentsDataList() {
      // 更新userId，确保获取最新的用户ID
      this.userId = localStorage.getItem('userId') || '';
      this.$request.get("/contact/selectAgentContact?userId=" + this.userId).then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    
    // 打开客服弹窗
    Kefu() {
      this.getCommentsDataList();
      this.visible = true;
    }
  },
};
</script>

<style scoped lang="less">
#components-layout-demo-custom-trigger {
  height: 100vh;
}

/* 侧边栏整体样式 */
.custom-sider {
  background: #ffffff;
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
  z-index: 10;
}

/* Logo 样式 */
.logo {
  height: 64px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-bottom: 1px solid #f0f0f0;
}
.logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  border-radius: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  margin-right: 12px;
  box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
}
.logo-text {
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
  white-space: nowrap;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.5px;
}

/* 菜单样式重写 */
.custom-menu {
  border-right: none;
  padding-top: 16px;
}

/* 覆盖 Ant Design 菜单样式 */
:deep(.ant-menu-item), :deep(.ant-menu-submenu-title) {
  height: 50px !important;
  line-height: 50px !important;
  margin: 4px 12px !important;
  width: auto !important;
  border-radius: 8px;
  color: #4b5563;
  font-size: 15px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

:deep(.ant-menu-item:hover), :deep(.ant-menu-submenu-title:hover) {
  color: #1890ff;
  background-color: #f0f7ff;
}

/* 选中项样式 */
:deep(.ant-menu-item-selected) {
  background: linear-gradient(90deg, #1890ff 0%, #69c0ff 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
}

:deep(.ant-menu-item-selected:after) {
  display: none; /* 移除默认的右侧蓝色条 */
}

/* 子菜单选中时父级样式 */
:deep(.ant-menu-submenu-selected .ant-menu-submenu-title) {
  color: #1890ff;
  background-color: #f0f7ff;
}

/* 图标样式 */
:deep(.ant-menu-item .anticon), :deep(.ant-menu-submenu-title .anticon) {
  font-size: 18px;
  margin-right: 10px;
}

/* 收起时的图标居中 */
.ant-layout-sider-collapsed :deep(.ant-menu-item .anticon), 
.ant-layout-sider-collapsed :deep(.ant-menu-submenu-title .anticon) {
  margin-right: 0;
  font-size: 20px;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding-right: 24px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  position: relative;
  z-index: 5;
}
.header-right {
  display: flex;
  align-items: center;
}
.lang-btn {
  color: #1f2937;
  font-weight: 500;
  padding: 0 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    color: #1890ff;
  }
}
.user-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 12px;
  transition: all 0.3s;
  height: 64px;
}
.user-dropdown-link:hover {
  background: rgba(0, 0, 0, 0.025);
}
.avatar {
  margin-right: 8px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
}
.username {
  color: #1f2937;
  font-weight: 500;
  margin-right: 8px;
}

/* 页面切换动画 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>